import { render, staticRenderFns } from "./CompanyCreate.vue?vue&type=template&id=7c96cb72"
import script from "./CompanyCreate.vue?vue&type=script&lang=js"
export * from "./CompanyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c96cb72')) {
      api.createRecord('7c96cb72', component.options)
    } else {
      api.reload('7c96cb72', component.options)
    }
    module.hot.accept("./CompanyCreate.vue?vue&type=template&id=7c96cb72", function () {
      api.rerender('7c96cb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyCreate.vue"
export default component.exports